import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { runtimeConfigs } from 'src/config/runtimeConfigs';
import useSettings from 'src/hooks/useSettings';

function AuthRoute({ children }) {
  const { settings } = useSettings();

  const account = useSelector(state => state.account);

  const searchEnviroment = async () => {
    const enviroment = await runtimeConfigs();
    return enviroment.defaultLogin || 'cigam';
  };

  if (!account.user) {
    let { defaultLogin } = settings;

    if (!defaultLogin) {
      defaultLogin = searchEnviroment();
    }

    if (typeof defaultLogin === 'string') {
      switch (defaultLogin) {
        case 'cliente':
          return <Redirect to="/login-cliente" />;
        default:
          return <Redirect to="/login" />;
      }
    }
  }

  return children;
}

AuthRoute.propTypes = {
  AuthRoute: PropTypes.oneOfType([PropTypes.elementType, PropTypes.object]),
};

export default AuthRoute;
